import type { PrepaidExportModeEnum } from "../../../generated/backendClient";

export const DATEV_ACCOUNT_LABELS: Record<string, string> = {
  REVENUE_BASE_FEE: "Erlöse: Grundgebühr",
  REVENUE_DRIVING_LESSON: "Erlöse: Fahrstunden",
  B2B_REGISTRATION_EXPENSE: "Registrierungsgebühren",
  B2B_PLATFORM_EXPENSE: "Plattformgebühren",
  AUTHORITY_FEE: "Behördengebühren",
  B2B_MIXED_EXPENSE: "Gemischte AUTOVIO-Gebühren",
  B2B_PAYMENT_EXPENSE: "Zahlungsgebühren",
  HQ_CREDITOR: "AUTOVIO-Kreditor",
  PREPAID_LIABILITY: "Schülerguthaben",
  STRIPE_RECEIVABLE: "Zahlungsanbieter",
  PAYOUT_CLEARING: "Stripe-Auszahlungen",
  CASH_PAYMENT_ACCOUNT: "Kasse",
  BANK_TRANSFER_ACCOUNT: "Bank",
  OPENING_BALANCE: "Eröffnungsbilanz",
  PREPAID_CLEARING: "Guthabenverrechnung",
};
export const DATEV_ACCOUNT_DESCRIPTIONS: Record<string, string> = {
  REVENUE_BASE_FEE:
    "Erlöskonto für Grundgebühren. Wird auch für Rechnungspositionen ohne eigene Erlöszuordnung verwendet.",
  REVENUE_DRIVING_LESSON: "Erlöskonto für Fahrstunden und Sonderfahrten.",
  B2B_REGISTRATION_EXPENSE: "Aufwandskonto für Registrierungsgebühren, die AUTOVIO der Fahrschule berechnet.",
  B2B_PLATFORM_EXPENSE: "Aufwandskonto für die Nutzung der AUTOVIO-Plattform.",
  B2B_PAYMENT_EXPENSE: "Aufwandskonto für Zahlungsabwicklungsgebühren auf AUTOVIO-Rechnungen.",
  B2B_MIXED_EXPENSE: "Aufwandskonto für AUTOVIO-Gebühren, die gemeinsam statt nach Gebührenart gebucht werden.",
  AUTHORITY_FEE: "Konto für weiterberechnete Behörden- und Prüfungsgebühren, zum Beispiel von TÜV oder DEKRA.",
  HQ_CREDITOR: "Kreditorenkonto für AUTOVIO. Hier werden AUTOVIO-Rechnungen und deren Verrechnung gebucht.",
  PREPAID_LIABILITY: "Verbindlichkeitskonto für noch nicht verbrauchtes Schülerguthaben.",
  STRIPE_RECEIVABLE: "Verrechnungskonto für Zahlungen über den Zahlungsanbieter bis zur Abrechnung oder Auszahlung.",
  PAYOUT_CLEARING: "Verrechnungskonto für Stripe-Auszahlungen. Die Bankeingänge werden gegen dieses Konto gebucht.",
  CASH_PAYMENT_ACCOUNT: "Kassenkonto für Barzahlungen, die direkt an die Fahrschule gehen.",
  BANK_TRANSFER_ACCOUNT: "Bankkonto für Überweisungen, die direkt auf dem Konto der Fahrschule eingehen.",
  OPENING_BALANCE: "Gegenkonto für die Übernahme von Anfangsbeständen beim Start des DATEV-Exports.",
  PREPAID_CLEARING: "Verrechnungskonto für Schülerguthaben gemäß den hinterlegten Buchungsregeln.",
};

export const DATEV_MODE_LABELS: Record<string, string> = {
  MONTHLY: "Monatsabschluss",
  PAYMENTS: "Zahlungen",
  PAYOUT: "Auszahlung",
  OPENING: "Eröffnungsbestand",
  ALL: "Gesamtexport",
  CORRECTION: "Korrektur",
};

export const DATEV_ACCOUNT_GROUPS = [
  {
    label: "Erlöse",
    description: "Konten für deine Ausbildungsleistungen.",
    roles: ["REVENUE_BASE_FEE", "REVENUE_DRIVING_LESSON"],
  },
  {
    label: "Gebühren und Aufwendungen",
    description: "Konten für Gebühren von Behörden.",
    roles: ["AUTHORITY_FEE"],
  },
  {
    label: "AUTOVIO",
    description: "Gebühren und Kreditor für AUTOVIO.",
    roles: [
      "B2B_REGISTRATION_EXPENSE",
      "B2B_PLATFORM_EXPENSE",
      "B2B_PAYMENT_EXPENSE",
      "B2B_MIXED_EXPENSE",
      "HQ_CREDITOR",
    ],
  },
  {
    label: "Zahlungsverkehr",
    description: "Konten für direkte Zahlungen und den Zahlungsanbieter.",
    roles: ["CASH_PAYMENT_ACCOUNT", "BANK_TRANSFER_ACCOUNT", "STRIPE_RECEIVABLE", "PAYOUT_CLEARING"],
  },
  {
    label: "Guthaben und Verrechnung",
    description: "Konten für Schülerguthaben und deren Verrechnung.",
    roles: ["PREPAID_LIABILITY", "PREPAID_CLEARING"],
  },
  {
    label: "Interne Einstellungen",
    description: "Technische Kontenzuordnungen für AUTOVIO-Mitarbeiter.",
    roles: ["OPENING_BALANCE"],
  },
];

export function getDATEVAccountLabel(role: string) {
  return DATEV_ACCOUNT_LABELS[role] ?? `Weiteres Konto: ${role.replaceAll("_", " ")}`;
}

export const DATEV_PREPAID_EXPORT_LABELS: Record<PrepaidExportModeEnum, string> = {
  FULL: "Guthaben gemäß Buchungsart berücksichtigen",
  SERVICES_ONLY: "Nur Leistungen (ohne Guthabenbuchungen)",
};
